import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {ScreenDoor} from './ScreenDoor'
import {CloseX} from './CloseX'
import {BulletLine} from './BulletLine'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'


const boxStyle: React.CSSProperties = {
    height: '240px',
    width: '380px',
    position: 'absolute',
    top: '50%',
    marginTop: '-120px',
    left: '50%',
    marginLeft: '-190px',
    padding: '20px',
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    '@media (max-width:414px)': {
        width:'322px',
    },
    '@media (max-width:375px)': {
        width:'300px',
        marginLeft:'-172px'
    },
    '@media (max-width:320px)': {
        width:'270px',
        marginLeft:'-155px'
    }
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    height: '30px',
    alignItems: 'center'
}

const lblStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    height: '25px',
    lineHeight: '25px',
    fontSize: '18px',
    marginRight: '8px',
    flexGrow: 0,
    '@media (max-width:320px)': {
        marginRight:'25px'
    }
}

const inputStyle: React.CSSProperties = {
    backgroundColor: Tgcc.Styles.inputBackground,
    border: 'none',
    height: '25px',
    lineHeight: '25px',
    padding: '0 4px',
    fontSize: '16px',
    flexGrow: 1
}

const workStyle: React.CSSProperties = {
    verticalAlign: 'middle',
    width: '44px',
    alignSelf: 'center',
    filter: 'grayscale(90%)'
}

let forgotRowStyle = Object.assign({}, rowStyle, {justifyContent: 'flex-end', height: 'auto', marginTop: '-10px'})
const forgotLinkStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'flex-end',
    fontSize: '11px',
    padding: '2px'
}

class _Impersonate extends React.Component<Tgcc.BaseProps, any> {
    state: any = {
        error: "",
        email: "",
        password: "",
        isWaiting: false
    };

    cancelLogin = () => {
        this.setState({isWaiting: false});
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null})
    }

    failed = (err: any) => {
        this.setState({isWaiting: false, error: err});
    }

    success = (uData: {loginData: Tgcc.LoginData, userInfo: Tgcc.UserInfo}) => {
        this.props.dispatch({type: Tgcc.StateAction.Impersonate, payload: uData});
    }

    doImpersonate = () => {
        if(!this.state.email)
            this.setState({error: 'Email cannot be blank'});
        else if(!Tgcc.IsValidEmail(this.state.email))
            this.setState({error: 'Email is not valid'});
        else {
            Request.canImpersonate(this.props.state.LoginData.token, this.state.email, 
            () => {
                var lData = Object.assign({}, this.props.state.LoginData, {impersonate: this.state.email});
                Tgcc.successfulLogin(this.props.dispatch, lData);
            },
            (err) => { this.setState({error: err})});
        }
    }

    emailChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({email: evt.currentTarget.value});
    }

    keyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doImpersonate();
    }


    render(){
        var btnElement = this.state.isWaiting ? 
            Tgcc.workingGif
            : <div className="grayButton" style={Tgcc.Styles.grayButton} onClick={this.doImpersonate}>Impersonate</div>

        var errElement = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div> : <div/>
        return(
            <ScreenDoor>
                <div style={boxStyle}>
                    <BulletLine text="Impersonate" fontSize="14px" bulletSize="5px" />
                    <CloseX closeAction={this.cancelLogin} />
                    {errElement}
                    <div style={rowStyle}>
                        <div style={lblStyle}>Customer Email</div>
                        <input autoFocus type='text' style={inputStyle} name='email' onChange={this.emailChanged} onKeyPress={this.keyPressed}/>
                    </div>
                    {btnElement}
                </div>
            </ScreenDoor>
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var Impersonate = connect(mapStateToProps)(Radium(_Impersonate));